import {combineReducers} from 'redux';

import creds from './credsReducer';
import orders from './ordersReducer';
import files from './filesReducer';
import comment from './commReducer';

const reducer = combineReducers({creds, files, orders, comment});

export default reducer;


// WEBPACK FOOTER //
// ./src/app/reducers/rootReducer.js